<div style="border: 1px solid red">logout Component</div>